module.exports = __webpack_public_path__ + "basic_bw.svg?9e89f2ccec19a6366bf3ca3ff3fcebfc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/basic_bw.svg
// module id = 14
// module chunks = 0